import React, {useEffect, useState, useCallback} from "react";
import Dashboard from "../../components/dashboard/dashboard";
import PageHeaderBar from "../../components/page/components/page-header-bar/page-header-bar";
import PageSection from "../../components/page/components/page-section/page-section";
import {createOperationService, downloadRecordingService} from "../../services/commonService";
import {useKeycloak} from "@react-keycloak/web";
import {useParams} from "react-router-dom";
import {
    STREAM_SOURCE_OPERATION_DOWNLOAD_RECORDING,
    STREAM_SOURCE_OPERATION_LIST_RECORDINGS,
    STREAM_SOURCE_OPERATION_STATUS
} from "./local-records-constants";
import DisksData from "../source/disks-data/disks-data";
import withStyles from "../../components/with-styles/with-styles";
import styles from "../../components/table/paginated-table/styles/paginated-table.css";
import Loading from "../../components/graphql/query-response-handler/loading/loading";
import {getMultilangMessage} from "../../utils/multilang";
import LocalRecordingsTableComponent from "./partial/local-recordings-table-component";

const LocalRecordsPage = () => {

    const {keycloak, initialized} = useKeycloak();
    const {id} = useParams();

    const [disks, setDisks] = useState(null);
    const [recordings, setRecordings] = useState(null);
    const [loadingDownload, setLoadingDownload] = useState(null);

    const handleSetDisks = data => {
        setDisks(data.content.disks_available)
    };

    const handleSetRecordings = data => {
        setRecordings(data);
    };

    const handleSetLoadingDownload = value => {
        setLoadingDownload(value)
    }

    const handleDownloadRecording = useCallback(item => {
        handleSetLoadingDownload(item.recording_id)
        downloadRecordingService({
            streamsourceId: id, recording_id: item.recording_id, action: STREAM_SOURCE_OPERATION_DOWNLOAD_RECORDING
        }, handleSetLoadingDownload)
    }, []);

    const handleGetDisks = () => {
        createOperationService({streamsourceId: id, action: STREAM_SOURCE_OPERATION_STATUS}, handleSetDisks)
    }

    const handleGetRecordings = useCallback(() => {
        createOperationService({
            streamsourceId: id,
            action: STREAM_SOURCE_OPERATION_LIST_RECORDINGS
        }, handleSetRecordings)
    }, [])

    useEffect(() => {
        if (keycloak && initialized) {
            handleGetDisks()
            handleGetRecordings()
        }
    }, [keycloak, initialized]);

    return <Dashboard>
        <PageHeaderBar title="app.page.source.local.recordings.title"/>

        <PageSection>
            <PageHeaderBar subtitle title={"app.page.source.disks.title"}/>
            {disks === null ? <Loading message={getMultilangMessage("common.loading")}/> :
                disks.map((disk, index) => <DisksData key={index} name={disk.id} status={disk.status}
                                                      totalDisk={disk.total_disk} occupiedDisk={disk.occupied_disk}/>)}
            <PageHeaderBar subtitle title={"app.page.source.local.recordings.title"}/>
            {recordings === null ?
                <Loading message={getMultilangMessage("common.loading")}/> :
                <LocalRecordingsTableComponent data={recordings} handleDownload={handleDownloadRecording}
                                               loadingDownload={loadingDownload}/>}
        </PageSection>
    </Dashboard>
}

export default withStyles(styles)(LocalRecordsPage);